import { render, staticRenderFns } from "./EmailTemplateLinkProfile.vue?vue&type=template&id=e90596c2&scoped=true&"
import script from "./EmailTemplateLinkProfile.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateLinkProfile.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateLinkProfile.vue?vue&type=style&index=0&id=e90596c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90596c2",
  null
  
)

export default component.exports